/**
 * DemoBanner — slim app-wide strip shown when REACT_APP_DEMO_MODE=true.
 * Reassures prospects they are seeing the real product on isolated demo data.
 * Dismissible per session. Renders nothing in non-demo builds (production).
 */
import React, { useState } from "react";
import { X } from "lucide-react";
import { SHOW_DEMO_TOOLS as DEMO_MODE } from "../lib/demoMode";

export default function DemoBanner() {
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("demoBannerHidden") === "1");
  if (!DEMO_MODE || hidden) return null;
  return (
    <div
      className="w-full bg-[#0b1f3a] text-white text-center text-xs sm:text-sm px-4 py-1.5 flex items-center justify-center gap-3"
      data-testid="demo-mode-banner"
    >
      <span className="flex items-center gap-2 flex-wrap justify-center">
        <span className="inline-flex items-center justify-center w-4 h-4 rounded-sm bg-[#FFC107] text-[#0b1f3a] font-black text-[10px] leading-none">D</span>
        <strong className="font-semibold">Crystal Dispatch Demonstration Environment</strong>
        <span className="text-white/70 hidden sm:inline">— realistic demo data. Production systems and live customer data are completely separate.</span>
      </span>
      <button
        onClick={() => { sessionStorage.setItem("demoBannerHidden", "1"); setHidden(true); }}
        className="text-white/60 hover:text-white flex-shrink-0"
        aria-label="Dismiss demo banner"
        data-testid="demo-banner-dismiss"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
